'use strict';

var $emptyNode = document.createElement('div');


/**
 * Rectangle static render function.
 *
 * @this Object
 *
 * @param {Node} $node DOM element of list item
 */
function rectangleRender ( $node ) {
    /*
    <div class="content-item-rectangle-card">
        <div class="content-item-rectangle-card-shadow"></div>
        <div class="content-item-rectangle-card-container" style="background-color: #ff6650;">
            <div class="content-item-rectangle-card-icon" style="background-image: url('app/img/720/icons/karaoke.placeholder.png')"></div>
            <div class="content-item-rectangle-card-info">
                <div class="content-item-rectangle-card-name">Scorpions</div>
                <div class="content-item-rectangle-card-description">Return to Forever </div>
            </div>
        </div>
        <div class="content-item-rectangle-card-fullinfo">
            <div class="content-item-rectangle-card-title">Return to Forever</div>
            <div class="content-item-rectangle-card-metadata">Scorpions</div>
        </div>
    </div>
    */
    $node.className = 'content-item-rectangle-card';

    $node.$shadow = $node.appendChild(document.createElement('div'));
    $node.$shadow.className = 'content-item-rectangle-card-shadow';

    $node.$container = $node.appendChild(document.createElement('div'));
    $node.$container.className = 'content-item-rectangle-card-container';
    $node.$container.style.backgroundColor = this.data.colors.background;

    if ( typeof this.data.icon === 'string' ) {
        $node.$icon = $node.$container.appendChild(document.createElement('div'));
        $node.$icon.className = 'content-item-rectangle-card-icon';
        $node.$icon.style.backgroundImage = 'url("' + this.data.icon + '")';
    } else if ( this.data.icon.normal ) {
        $node.$icon = $node.$container.appendChild(document.createElement('div'));
        $node.$icon.className = 'content-item-rectangle-card-icon';
        $node.$icon.style.backgroundImage = 'url("' + this.data.icon.normal + '")';
    }

    $node.$info = $node.$container.appendChild(document.createElement('div'));
    $node.$info.className = 'content-item-rectangle-card-info';

    // if ( this.data.description ) {
    $node.$name = $node.$info.appendChild(document.createElement('div'));
    $node.$name.className = 'content-item-rectangle-card-name';
    $node.$name.innerText = this.data.name;

    $node.$description = $node.appendChild(document.createElement('div'));
    $node.$description.className = 'content-item-rectangle-card-description';
    $node.$description.innerText = this.data.name;

    // $node.$infoText = $emptyNode;
    // } else {
    //     $node.$description = $emptyNode;
    //     $node.$name = $emptyNode;

    //     $node.$infoText = $node.$info.appendChild(document.createElement('div'));
    //     $node.$infoText.className = 'content-item-rectangle-card-info-text';
    //     $node.$infoText.innerText = this.data.name;
    // }
}

/**
 * Square static render function.
 *
 * @this Object
 *
 * @param {Node} $node DOM element of list item
 */
function squareRender ( $node ) {
    /*
    <div class="content-item-static-square">
        <div class="content-item-square-card-shadow"></div>
        <div class="content-item-square-card-container" style="background-color: #53bf54;">
            <div class="content-item-square-card-icon" style="background-image: url('app/img/720/icons/audio.placeholder.png')"></div>
        </div>
        <div class="content-item-square-card-title">145. BBC Radio One</div>
    </div>
    */
    $node.className = 'content-item-square-card';

    $node.$shadow = $node.appendChild(document.createElement('div'));
    $node.$shadow.className = 'content-item-square-card-shadow';

    $node.$container = $node.appendChild(document.createElement('div'));
    $node.$container.className = 'content-item-square-card-container';
    $node.$container.style.backgroundColor = this.data.colors.background;

    if ( this.data.icon ) {
        $node.$container.hasImage = false;
        $node.$container.style.backgroundImage = 'url("' + this.data.icon.normal + '")';
    } else if ( this.data.image ) {
        $node.$container.hasImage = true;
        $node.$container.style.backgroundImage = 'url("' + this.data.image.normal + '")';
        $node.$container.className = 'content-item-square-card-container content-item-square-card-container--image';
    }

    $node.$title = $node.$container.appendChild(document.createElement('div'));
    $node.$title.className = 'content-item-square-card-title';
    $node.$title.innerText = this.data.name;


    // if ( this.data.text ) {
    //     if ( typeof this.data.icon === 'string' ) {
    //         $node.$icon = $node.$container.appendChild(document.createElement('div'));
    //         $node.$icon.className = 'content-item-square-card-icon';
    //         $node.$icon.style.backgroundImage = 'url("' + this.data.icon + '")';
    //     } else if ( this.data.icon.normal ) {
    //         $node.$icon = $node.$container.appendChild(document.createElement('div'));
    //         $node.$icon.className = 'content-item-square-card-icon';
    //         $node.$icon.style.backgroundImage = 'url("' + this.data.icon.normal + '")';
    //     } else {
    //         $node.$icon = $emptyNode;
    //     }
    //
    //     $node.$title = $node.$container.appendChild(document.createElement('div'));
    //     $node.$title.className = 'content-item-square-card-title';
    //     $node.$title.innerText = this.data.text;
    // } else {
    //     // no title, large icon
    //     if ( this.data.icon ) {
    //         $node.$container.style.backgroundImage = 'url("' + this.data.icon + '")';
    //         $node.$icon = $emptyNode;
    //     } else {
    //         $node.$icon = $emptyNode;
    //     }
    //
    //     $node.$title = $emptyNode;
    // }

    //$node.$info = $node.appendChild(document.createElement('div'));
    //$node.$info.className = 'content-item-square-card-info';

    /*$node.$name = $node.$info.appendChild(document.createElement('div'));
    $node.$name.className = 'content-item-square-card-name';
    $node.$name.innerText = this.data.name;*/

    if ( this.data.description ) {
        $node.$description = $node.$container.appendChild(document.createElement('div'));
        $node.$description.className = 'content-item-square-card-description';
        $node.$description.innerText = this.data.description;
    } else {
        $node.$description = $emptyNode;
    }

    /*if ( this.data.meta ) {
        $node.$meta = $node.$info.appendChild(document.createElement('div'));
        $node.$meta.className = 'content-item-square-card-metadata';

        $node.$meta.innerText = this.data.meta.join(' • ');
    } else {
        $node.$meta = $emptyNode;
    }*/
}

module.exports = {
    square: {
        render: squareRender,

        focus: function ( $node ) {
            $node.$shadow.className = 'content-item-square-card-shadow--focus';
            $node.$container.className = 'content-item-square-card-container--focus' +
                ($node.$container.hasImage ? ' content-item-square-card-container--image' : '');
            //$node.$icon.className = 'content-item-square-card-icon--focus';
            $node.$title.className = 'content-item-square-card-title--focus';
            //$node.$info.className = 'content-item-square-card-info--focus';
            //$node.$name.className = 'content-item-square-card-name--focus';
            $node.$description.className = 'content-item-square-card-description--focus';
            //$node.$meta.className = 'content-item-square-card-metadata--focus';

            if ( !$node.$container.hasImage ) {
                $node.$container.style.backgroundImage = 'url("' + this.data.icon.active + '")';
            }
        },

        blur: function ( $node ) {
            $node.$shadow.className = 'content-item-square-card-shadow';
            $node.$container.className = 'content-item-square-card-container' +
                ($node.$container.hasImage ? ' content-item-square-card-container--image' : '');
            //$node.$icon.className = 'content-item-square-card-icon';
            $node.$title.className = 'content-item-square-card-title';
            //$node.$info.className = 'content-item-square-card-info';
            //$node.$name.className = 'content-item-square-card-name';
            $node.$description.className = 'content-item-square-card-description';
            //$node.$meta.className = 'content-item-square-card-metadata--focus';

            if ( !$node.$container.hasImage ) {
                $node.$container.style.backgroundImage = 'url("' + this.data.icon.normal + '")';
            }
        }
    },
    rectangle: {
        render: rectangleRender,

        focus: function ( $node ) {
            $node.$shadow.className = 'content-item-rectangle-card-shadow--focus';
            $node.$container.className = 'content-item-rectangle-card-container--focus';
            $node.$icon.className = 'content-item-rectangle-card-icon--focus';
            $node.$info.className = 'content-item-rectangle-card-info--focus';
            $node.$name.className = 'content-item-rectangle-card-name--focus';
            $node.$description.className = 'content-item-rectangle-card-description--focus';

            if ( this.data.icon.active ) {
                $node.$icon.style.backgroundImage = 'url("' + this.data.icon.active + '")';
            }
        },

        blur: function ( $node ) {
            $node.$shadow.className = 'content-item-rectangle-card-shadow';
            $node.$container.className = 'content-item-rectangle-card-container';
            $node.$icon.className = 'content-item-rectangle-card-icon';
            $node.$info.className = 'content-item-rectangle-card-info';
            $node.$name.className = 'content-item-rectangle-card-name';
            $node.$description.className = 'content-item-rectangle-card-description';

            if ( typeof this.data.icon === 'string' ) {
                $node.$icon.style.backgroundImage = 'url("' + this.data.icon + '")';
            } else if ( this.data.icon.normal ) {
                $node.$icon.style.backgroundImage = 'url("' + this.data.icon.normal + '")';
            }
        }
    }
};
